import { MouseEvent, ReactNode } from 'react';
import { MdIosShare, MdOutlineGrade, MdOutlinePushPin } from 'react-icons/md';
import { Event } from '@blisspointmedia/bpm-types/dist/OracleActivity';
import { Badge } from '@Components/Badge';
import { IconButton } from '@Components/IconButton';
import { Appearance } from '@Components/designConstants';
import { ActivityFeedClientBadge } from '../ActivityFeedClientBadge';
import { GHOST_ICON_BUTTON_PROPS } from '../activity-feed-constants';
import {
  getProvenanceDisplay,
  nextPinAction,
  nextStarAction,
  useNotImplemented
} from '../activity-feed-utils';
import { useToggleActivityState } from '../useOracleEventMutations';
import { getSignalBadge } from './activity-feed-detail-utils';
import { DetailActionsMenu } from './DetailActionsMenu';

interface DetailBadgesRowProps {
  event: Event;
  showWip: boolean;
  isEditing: boolean;
  onEdit: () => void;
}

export const DetailBadgesRow = ({
  event,
  showWip,
  isEditing,
  onEdit
}: DetailBadgesRowProps): ReactNode => {
  const {
    id: activityId,
    origin,
    signalTag,
    importance,
    isStarred = false,
    isPinned = false
  } = event;
  const provenance = getProvenanceDisplay(origin);
  const signalBadge = getSignalBadge(signalTag, importance);
  const { icon: ProvenanceIcon } = provenance;
  const { icon: SignalIcon } = signalBadge;
  const notImplemented = useNotImplemented();
  const toggle = useToggleActivityState();

  const handleStar = (e: MouseEvent) => toggle(e, activityId, nextStarAction(isStarred));
  const handlePin = (e: MouseEvent) => toggle(e, activityId, nextPinAction(isPinned));

  return (
    <div className='activity-feed-detail-badges'>
      <div className='activity-feed-detail-badges-left'>
        <ActivityFeedClientBadge cid={event.cid} appearance={Appearance.OUTLINED} />
        <Badge design={provenance.design} leadingElement={<ProvenanceIcon />}>
          {provenance.label} Event
        </Badge>
        <Badge
          design={signalBadge.design}
          appearance={Appearance.OUTLINED}
          leadingElement={<SignalIcon />}
        >
          {signalBadge.label}
        </Badge>
      </div>
      <div className='activity-feed-detail-badges-right'>
        {showWip && (
          <>
            <IconButton {...GHOST_ICON_BUTTON_PROPS} onClick={notImplemented}>
              <MdIosShare />
            </IconButton>
            <IconButton {...GHOST_ICON_BUTTON_PROPS} onClick={handleStar}>
              <MdOutlineGrade />
            </IconButton>
            <IconButton {...GHOST_ICON_BUTTON_PROPS} onClick={handlePin}>
              <MdOutlinePushPin />
            </IconButton>
          </>
        )}
        <DetailActionsMenu event={event} showWip={showWip} isEditing={isEditing} onEdit={onEdit} />
      </div>
    </div>
  );
};
